/** Harita üzerinde gösterilebilen nesne türleri (vendor'dan bağımsız). */
export type GisEntityName = 'MAHALLE' | 'CADDE' | 'BINA' | 'KAPI' | 'PARSEL';

export const GIS_ENTITY_NAMES: readonly GisEntityName[] = ['MAHALLE', 'CADDE', 'BINA', 'KAPI', 'PARSEL'];

/**
 * Formlardan gelen metni (ör. 'BINA', 'bina') desteklenen nesne adına çevirir.
 * Desteklenmeyen bir ad gelirse null döner.
 */
export function normalizeGisEntityName(text: string | null | undefined): GisEntityName | null {
  const key = (text ?? '').trim().toLocaleUpperCase('en-US').replace(/İ/g, 'I');
  return (GIS_ENTITY_NAMES as readonly string[]).includes(key) ? (key as GisEntityName) : null;
}

/** Haritadan gelen konum/adres alanları (GiSoft `messageArgs` ile birebir). */
export interface GisLocationInfo {
  cityUavtId?: number | string;
  cityName?: string;
  countyUavtId?: number | string;
  countyName?: string;
  districtUavtId?: number | string;
  districtName?: string;
  roadDistrictUavtId?: number | string;
  roadName?: string;
  doorUavtId?: number | string;
  doorNumber?: string;
  longitude?: number | string;
  latitude?: number | string;
}

/** Haritada bir nesne seçilip "Ybs'de göster" denildiğinde gelir. GiSoft değerleri metin olarak gönderir. */
export interface GisEntityInfo extends GisLocationInfo {
  entityName?: string;
  entityId?: number | string;
  entityUavtId?: number | string;
}

/** Haritada "Adres ve Koordinat Alma" ile bir noktaya tıklandığında gelir. */
export type GisAddressInfo = GisLocationInfo;

export interface GisError {
  errorCode?: number | string;
  errorMessage?: string;
}

/** Harita uygulamasından gelen mesajların vendor'dan bağımsız karşılığı. */
export type GisInboundEvent =
  | { type: 'ready' }
  | { type: 'entityInfo'; info: GisEntityInfo }
  | { type: 'addressInfo'; info: GisAddressInfo }
  | { type: 'error'; error: GisError }
  | { type: 'unknown'; name: string };
